import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { AuthRedirectService, AuthRedirectStorageService, AuthService, GlobalMessageType } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'
import { CustomGlobalMessageService } from '../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../services/shared/shared.service'
import { UserPermissionService } from '../services/user-permission/user-permission.service'

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsGuard  {
  constructor(
    public router: Router,
    public userPermissionService: UserPermissionService,
    public authService: AuthService,
    public globalMessageService: CustomGlobalMessageService,
    public sharedService: SharedService,
    public authRedirectService: AuthRedirectService,
    protected authRedirectStorageService: AuthRedirectStorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isUserLoggedIn().pipe(
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
          return this.userPermissionService.canVisit(route.url).pipe(map((visit) => this.validateVisit(visit)))
        } else {
          const redirect = this.canRedirect(route)
          if (redirect) {
            // TODO:Spartacus - Method 'reportAuthGuard' was removed from Class 'AuthRedirectService'. Use 'saveCurrentNavigationUrl' method instead.
            this.authRedirectService.saveCurrentNavigationUrl()
            this.authRedirectStorageService
              .getRedirectUrl()
              .pipe(take(1))
              .subscribe((redirectUrl) => {
                this.sharedService.urlAfterLogin = redirectUrl
              })
          }
          return this.userPermissionService.canVisitWithoutLogin(route.url).pipe(
            map((visit) => {
              if (redirect && !visit) {
                this.router.navigateByUrl('/login')
                return false
              }
              return this.validateVisit(visit)
            })
          )
        }
      })
    )
  }

  private validateVisit(visit: boolean): boolean {
    if (visit) {
      return true
    }
    this.router.navigateByUrl('/').then(() => {
      this.globalMessageService.add({ key: 'shared.notAuthorized' }, GlobalMessageType.MSG_TYPE_ERROR)
    })
    return false
  }

  private canRedirect(route: ActivatedRouteSnapshot): boolean {
    if (!route.url.length) {
      return false
    }
    for (const url of route.url) {
      if (['login', 'logout'].includes(url.path)) {
        return false
      }
    }
    return true
  }
}
